const { __ } = wp.i18n;

export default {
  lessText: __('Show less', 'canopia'),
  moreText: __('Show more', 'canopia'),
  onButtonClick(event)
  {
    event.preventDefault();
    let button = event.target;

    if('true' !== button.dataset.open) {
      if('true' !== button.dataset.loaded) {
        this.loadCards(button);
      } else {
        let wrapper = button.closest('.load-card-wrapper');
        if(wrapper && !wrapper.classList.contains('items-loaded')) {
          wrapper.classList.add('items-loaded')
        }
        this.showCards(button);
      }
    } else {
      this.hideCards(button);
    }
  },
  showLoadMoreMutton(button)
  {
    const wrapper = button.parentElement;
    const total = button.dataset.total || 0;
    let cols = button.dataset.cols || 3;

    if(undefined !== button.dataset.colsMd && window.matchMedia("(min-width: 768px)").matches) {
      cols = parseInt(button.dataset.colsMd);
    }

    if (total > cols) {
      wrapper.removeAttribute('style');
      return true;
    } else {
      return false;
    }
  },
  getCardElements(button)
  {
    let wrapper = button.closest('.load-card-wrapper');

    return wrapper ? wrapper.querySelectorAll('.load-card-col') : false;
  },
  showCards(button)
  {
    let cards = this.getCardElements(button);

    if(cards && cards.length > 0) {
      cards.forEach(card => card.removeAttribute('style'));
      button.dataset.open = 'true';
      button.textContent = this.lessText;
    }
  },
  hideCards(button)
  {
    let cards = this.getCardElements(button);
    let cols = undefined !== button.dataset.cols ? parseInt(button.dataset.cols) : 3;

    if(undefined !== button.dataset.colsMd && window.matchMedia("(min-width: 768px)").matches) {
      cols = parseInt(button.dataset.colsMd);
    }
    if(cards && cards.length > 0) {
      cards.forEach((card, index) => {
        if(index >= cols) {
          card.style.display = 'none';
        }
      });
      button.dataset.open = 'false';
      button.textContent = this.moreText;
    }
  },
  async loadCards(button) {
    const postType = button.dataset.postType || 'howto';
    const total = button.dataset.total;
    button.disabled = true;
    button.classList.add('loading');

    try {
      let data = {
        action: `palram_${button.dataset.action}`,
        secure: palram.nonces.get_cards,
        lang: palram.lang,
        postType,
        total
      };

      if(undefined !== button.dataset.productId) {
        data.productId = button.dataset.productId;
      }

      let response = await this.getCards(data);

      if(response.success) {
        button.parentElement.insertAdjacentHTML('beforebegin', response.data.html);
        button.parentElement.parentElement.classList.add('items-loaded');
        button.dataset.loaded = 'true';
        button.dataset.open = 'true';
        button.textContent = this.lessText;
      }
    } catch (e) {

    } finally {
      button.disabled = false;
      button.classList.remove('loading');
    }
  },
  async getCards(data) {
    return $.ajax({
      url: palram.ajax_url,
      method: 'GET',
      data,
    })
  },
  init() {
    const buttons = document.querySelectorAll('.ajax-load-cards');
    if(buttons && buttons.length > 0) {
      buttons.forEach(button => {
        if(this.showLoadMoreMutton(button)) {
          button.addEventListener('click', this.onButtonClick.bind(this))
        }
      });
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
